"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDeleteStackEvent = exports.isNoChangeDeleteStackEvent = exports.isFailureDeleteStackEvent = exports.isSuccessfulDeleteStackEvent = exports.isUpdateStackEvent = exports.isFailureUpdateStackEvent = exports.isNoChangeUpdateStackEvent = exports.isSuccessfulUpdateStackEvent = exports.isCreateStackEvent = exports.isFailureCreateStackEvent = exports.isSuccessfulCreateStackEvent = exports.isCreateStackBaseEvent = exports.CoreVersion = exports.StackApiKeys = exports.InactiveStack = exports.isInactiveStack = exports.QueryUsageSample = exports.DiskUsageSample = exports.DataUsageSample = exports.StackLastActive = exports.StackHistoryEvent = exports.isStackHistoryEvent = exports.UpdateStack = exports.isUpdateStack = exports.CreateStack = exports.isCreateStack = exports.StackPreview = exports.PendingStack = exports.isPendingStack = exports.isPartialStack = exports.isFailedStack = exports.Stack = exports.isStack = exports.isSuccessfulStack = exports.parseCFNStackEvent = exports.isCFNUsagePlanResourceStackEvent = exports.isCFNStackResourceStackEvent = exports.isCFNStackEvent = exports.isAwsSnsNotification = exports.isUsagePlanResourceType = exports.isStackResourceType = exports.AwsApiGatewayUsagePlan = exports.AwsCloudFormationStack = exports.AwsSnsCloudFormationNotification = exports.isStackStatus = exports.isStackOperationOutcome = exports.isNoChangeStackOperationOutcome = exports.isFailureStackOperationOutcome = exports.isSuccessfulStackOperationOutcome = exports.isStackOperation = void 0;
exports.isStackEvent = exports.isCancelStackEvent = void 0;
require("reflect-metadata");
const lodash_1 = __importDefault(require("lodash"));
const date_fns_1 = require("date-fns");
const InstanceSize_1 = require("./InstanceSize");
const HostnameConfig_1 = require("./HostnameConfig");
const ApplicationVersionConfig_1 = require("./ApplicationVersionConfig");
const validation_1 = require("../validator/validation");
const uuid_1 = require("../types/uuid");
const datelike_1 = require("../types/datelike");
const subdomain_1 = require("../types/subdomain");
const QueryLimits_1 = require("./QueryLimits");
const ValidatorClass_1 = require("../validator/ValidatorClass");
exports.isStackOperation = (0, validation_1.isLiteral)('CREATE', 'UPDATE', 'DELETE', 'CANCEL');
exports.isSuccessfulStackOperationOutcome = (0, validation_1.isLiteral)('SUCCESS');
exports.isFailureStackOperationOutcome = (0, validation_1.isLiteral)('FAILURE');
exports.isNoChangeStackOperationOutcome = (0, validation_1.isLiteral)('NO_CHANGE');
exports.isStackOperationOutcome = (0, validation_1.isSomeOf)(exports.isSuccessfulStackOperationOutcome, exports.isFailureStackOperationOutcome, exports.isNoChangeStackOperationOutcome);
exports.isStackStatus = (0, validation_1.isLiteral)('CREATE_COMPLETE', 'CREATE_IN_PROGRESS', 'CREATE_FAILED', 'DELETE_COMPLETE', 'DELETE_FAILED', 'DELETE_IN_PROGRESS', 'REVIEW_IN_PROGRESS', 'ROLLBACK_COMPLETE', 'ROLLBACK_FAILED', 'ROLLBACK_IN_PROGRESS', 'UPDATE_COMPLETE', 'UPDATE_COMPLETE_CLEANUP_IN_PROGRESS', 'UPDATE_IN_PROGRESS', 'UPDATE_ROLLBACK_COMPLETE', 'UPDATE_ROLLBACK_COMPLETE_CLEANUP_IN_PROGRESS', 'UPDATE_ROLLBACK_FAILED', 'UPDATE_ROLLBACK_IN_PROGRESS', 'IMPORT_IN_PROGRESS', 'IMPORT_COMPLETE', 'IMPORT_ROLLBACK_IN_PROGRESS', 'IMPORT_ROLLBACK_FAILED', 'IMPORT_ROLLBACK_COMPLETE', 'INTERMEDIATE');
exports.AwsSnsCloudFormationNotification = 'AWS CloudFormation Notification';
exports.AwsCloudFormationStack = 'AWS::CloudFormation::Stack';
exports.AwsApiGatewayUsagePlan = 'AWS::ApiGateway::UsagePlan';
exports.isStackResourceType = (0, validation_1.isLiteral)(exports.AwsCloudFormationStack);
exports.isUsagePlanResourceType = (0, validation_1.isLiteral)(exports.AwsApiGatewayUsagePlan);
exports.isAwsSnsNotification = (0, validation_1.isObjectOf)({
    Type: (0, validation_1.isLiteral)('Notification'),
    MessageId: uuid_1.isUUID,
    Subject: (0, validation_1.isLiteral)(exports.AwsSnsCloudFormationNotification),
    Message: validation_1.isString.which((0, validation_1.satisfiesCondition)(s => (s === null || s === void 0 ? void 0 : s.trim().length) > 0)),
});
exports.isCFNStackEvent = (0, validation_1.isObjectOf)({
    ResourceType: validation_1.isString,
    StackId: validation_1.isString,
    EventId: validation_1.isString,
    StackName: validation_1.isString,
    LogicalResourceId: validation_1.isAny,
    PhysicalResourceId: validation_1.isString,
    Timestamp: datelike_1.isDateLike,
    ResourceStatus: exports.isStackStatus,
    ResourceStatusReason: (0, validation_1.optional)(validation_1.isString),
    ResourceProperties: (0, validation_1.optional)(validation_1.isString),
    ClientRequestToken: (0, validation_1.optional)(validation_1.isString),
});
exports.isCFNStackResourceStackEvent = exports.isCFNStackEvent.and((0, validation_1.isObjectOf)({
    ResourceType: exports.isStackResourceType,
}));
exports.isCFNUsagePlanResourceStackEvent = exports.isCFNStackEvent.and((0, validation_1.isObjectOf)({
    ResourceType: exports.isUsagePlanResourceType,
}));
const newlineDelimitedStringToTs = (snsMessage) => {
    const { Message: message } = snsMessage;
    const ukn = message === null || message === void 0 ? void 0 : message.split('\n').reduce((acc, cur) => {
        const [k, v] = cur.split(/='(.*)'$/);
        if (!lodash_1.default.isEmpty(k))
            acc[k.trim()] = v === null || v === void 0 ? void 0 : v.trim();
        return acc;
    }, {});
    return ukn;
};
function parseCFNStackEvent(snsMessage) {
    const ukn = newlineDelimitedStringToTs(snsMessage);
    if ((0, exports.isCFNStackEvent)(ukn))
        return ukn;
    return null;
}
exports.parseCFNStackEvent = parseCFNStackEvent;
const stackValidators = {
    uuid: uuid_1.isUUID,
    instanceGroupId: uuid_1.isUUID.or(validation_1.isUndefined),
    applicationVersion: ApplicationVersionConfig_1.isApplicationVersion,
    aitoInstanceId: uuid_1.isUUID,
    createdAt: datelike_1.isDateLike,
    deletedInAws: validation_1.isBoolean,
    hostname: validation_1.isString,
    hostnameConfig: (0, validation_1.isArrayOf)(HostnameConfig_1.isHostnameConfig),
    instanceSize: InstanceSize_1.isInstanceSize,
    extraStorage: (0, validation_1.isSomeOf)(validation_1.isNumber, validation_1.isNull, validation_1.isUndefined),
    operationType: exports.isStackOperation,
    outcome: exports.isStackOperationOutcome,
    stackId: validation_1.isString,
    stackName: validation_1.isString,
    updateWeekday: validation_1.isNumber,
    totalStorage: validation_1.isNaturalNumber,
};
const isStackParams = (0, validation_1.isObjectOf)(stackValidators);
const isPartialStackParams = (0, validation_1.isPartialObjectOf)(stackValidators);
const isDeletedStackParams = (0, validation_1.isPartialObjectOf)({
    ...stackValidators,
    hostnameConfig: validation_1.isUndefined.or(stackValidators.hostnameConfig.which((0, validation_1.satisfiesCondition)(a => (a === null || a === void 0 ? void 0 : a.length) === 0))),
});
exports.isSuccessfulStack = (0, validation_1.isAllOf)((0, validation_1.isObjectOf)({
    outcome: exports.isSuccessfulStackOperationOutcome,
    hostnameConfig: (0, validation_1.isArrayOf)(HostnameConfig_1.isHostnameConfig),
    stackStatus: exports.isStackStatus.or(validation_1.isUndefined),
}), isStackParams);
exports.isStack = (0, validation_1.isObjectOf)({
    ...stackValidators,
    operationType: (0, validation_1.optional)(exports.isStackOperation),
    outcome: (0, validation_1.optional)(exports.isStackOperationOutcome),
    hostnameConfig: (0, validation_1.optional)((0, validation_1.isArrayOf)(HostnameConfig_1.isHostnameConfig)),
    stackStatus: (0, validation_1.optional)(exports.isStackStatus.or((0, validation_1.isLiteral)('MISSING'))),
});
class Stack extends (0, ValidatorClass_1.ValidatorClass)(exports.isStack) {
}
exports.Stack = Stack;
exports.isFailedStack = (0, validation_1.isAllOf)((0, validation_1.isObjectOf)({
    outcome: (0, validation_1.optional)(exports.isFailureStackOperationOutcome),
    hostnameConfig: (0, validation_1.optional)((0, validation_1.isArrayOf)(HostnameConfig_1.isHostnameConfig)),
    stackStatus: exports.isStackStatus.or(validation_1.isUndefined),
}), isPartialStackParams);
exports.isPartialStack = (0, validation_1.isSomeOf)(exports.isSuccessfulStack, exports.isFailedStack, isDeletedStackParams);
exports.isPendingStack = (0, validation_1.isObjectOf)({
    operationInProgress: validation_1.isBoolean,
    pendingApplicationVersion: validation_1.isString,
    pendingInstanceSize: validation_1.isString,
    pendingInstanceGroupId: validation_1.isString,
});
class PendingStack extends (0, ValidatorClass_1.ValidatorClass)(exports.isPendingStack) {
}
exports.PendingStack = PendingStack;
const isStackPreview = (0, validation_1.isObjectOf)({
    uuid: uuid_1.isUUID,
    stackId: validation_1.isString,
    stackName: validation_1.isString,
    instanceSize: InstanceSize_1.isInstanceSize,
    extraStorage: (0, validation_1.optional)(validation_1.isNumber),
    applicationVersion: (0, validation_1.optional)(ApplicationVersionConfig_1.isApplicationVersion),
    createdAt: datelike_1.isDateLike,
    operationType: exports.isStackOperation,
    outcome: exports.isStackOperationOutcome,
    alwaysUpdate: validation_1.isBoolean,
    deletedInAws: validation_1.isBoolean,
});
class StackPreview extends (0, ValidatorClass_1.ValidatorClass)(isStackPreview) {
}
exports.StackPreview = StackPreview;
exports.isCreateStack = (0, validation_1.isObjectOf)({
    instanceGroupId: uuid_1.isUUID,
    teamName: (0, validation_1.optional)(validation_1.isString),
    aitoInstanceId: uuid_1.isUUID,
    subdomain: subdomain_1.isSubdomain,
    instanceSize: InstanceSize_1.isInstanceSize,
    totalStorage: validation_1.isNaturalNumber,
    applicationVersion: ApplicationVersionConfig_1.isApplicationVersion.or(ApplicationVersionConfig_1.isLatestVersion),
    queryLimits: QueryLimits_1.isQueryLimits,
});
class CreateStack extends (0, ValidatorClass_1.ValidatorClass)(exports.isCreateStack) {
}
exports.CreateStack = CreateStack;
exports.isUpdateStack = (0, validation_1.isObjectOf)({
    subdomain: (0, validation_1.optional)(subdomain_1.isSubdomain),
    instanceGroupId: uuid_1.isUUID,
    aitoInstanceId: uuid_1.isUUID,
    teamName: validation_1.isString,
    instanceSize: InstanceSize_1.isInstanceSize,
    totalStorage: (0, validation_1.optional)(validation_1.isNaturalNumber),
    applicationVersion: ApplicationVersionConfig_1.isApplicationVersion
        .or(ApplicationVersionConfig_1.isLatestVersion)
        .or(ApplicationVersionConfig_1.isCurrentVersion),
    queryLimits: (0, validation_1.optional)(QueryLimits_1.isQueryLimits),
});
class UpdateStack extends (0, ValidatorClass_1.ValidatorClass)(exports.isUpdateStack) {
}
exports.UpdateStack = UpdateStack;
exports.isStackHistoryEvent = (0, validation_1.isObjectOf)({
    stackName: validation_1.isString,
    createdAt: datelike_1.isDateLike,
    finishedAt: (0, validation_1.optional)(datelike_1.isDateLike),
    instanceSize: InstanceSize_1.isInstanceSize,
    applicationVersion: (0, validation_1.optional)(ApplicationVersionConfig_1.isApplicationVersion),
    operationType: validation_1.isString,
    outcome: (0, validation_1.optional)(validation_1.isString),
});
class StackHistoryEvent extends (0, ValidatorClass_1.ValidatorClass)(exports.isStackHistoryEvent) {
}
exports.StackHistoryEvent = StackHistoryEvent;
const isStackLastActive = (0, validation_1.isObjectOf)({
    lastActiveTime: datelike_1.isDateLike,
});
class StackLastActive extends (0, ValidatorClass_1.ValidatorClass)(isStackLastActive) {
}
exports.StackLastActive = StackLastActive;
const isDataUsageSample = (0, validation_1.isObjectOf)({
    atTime: datelike_1.isDateLike,
    environmentDataGb: (0, validation_1.optional)(validation_1.isNumber),
});
class DataUsageSample extends (0, ValidatorClass_1.ValidatorClass)(isDataUsageSample) {
}
exports.DataUsageSample = DataUsageSample;
const isDiskUsageSample = (0, validation_1.isObjectOf)({
    atTime: datelike_1.isDateLike,
    environmentDiskUsageGb: (0, validation_1.optional)(validation_1.isNumber),
});
class DiskUsageSample extends (0, ValidatorClass_1.ValidatorClass)(isDiskUsageSample) {
}
exports.DiskUsageSample = DiskUsageSample;
const isQueryUsageSample = (0, validation_1.isObjectOf)({
    atTime: datelike_1.isDateLike,
    totalCalls: (0, validation_1.optional)(validation_1.isNumber),
});
class QueryUsageSample extends (0, ValidatorClass_1.ValidatorClass)(isQueryUsageSample) {
}
exports.QueryUsageSample = QueryUsageSample;
exports.isInactiveStack = (0, validation_1.isObjectOf)({
    uuid: uuid_1.isUUID,
    lastUsed: (0, validation_1.optional)(datelike_1.isDateLike),
    createdAt: (0, validation_1.optional)(datelike_1.isDateLike),
});
class InactiveStack extends (0, ValidatorClass_1.ValidatorClass)(exports.isInactiveStack) {
    static daysSinceLastUse(it) {
        return it.lastUsed
            ? InactiveStack._daysSinceLastUsed(datelike_1.DateLike.toISOString(it.lastUsed), Date.now())
            : 0;
    }
    static _daysSinceLastUsed(isoDateString, now) {
        const ds = (0, date_fns_1.parseISO)(isoDateString);
        return (0, date_fns_1.differenceInCalendarDays)(now, ds);
    }
    static _sortOldestFirst(one, two) {
        return one.lastUsed && two.lastUsed
            ? (0, date_fns_1.differenceInSeconds)(datelike_1.DateLike.toDate(one.lastUsed), datelike_1.DateLike.toDate(two.lastUsed))
            : one.lastUsed
                ? 1
                : two.lastUsed
                    ? -1
                    : 0;
    }
    static sortOldestFirst(array = []) {
        return array.sort(this._sortOldestFirst);
    }
    static sortYoungestFirst(array = []) {
        return InactiveStack.sortOldestFirst(array).reverse();
    }
}
exports.InactiveStack = InactiveStack;
class StackApiKeys {
}
exports.StackApiKeys = StackApiKeys;
class CoreVersion {
}
exports.CoreVersion = CoreVersion;
exports.isCreateStackBaseEvent = (0, validation_1.isObjectOf)({
    operation: (0, validation_1.isLiteral)('CREATE'),
    stackId: uuid_1.isUUID,
});
exports.isSuccessfulCreateStackEvent = (0, validation_1.isAllOf)(exports.isCreateStackBaseEvent, (0, validation_1.isObjectOf)({
    outcome: exports.isSuccessfulStackOperationOutcome,
}));
exports.isFailureCreateStackEvent = (0, validation_1.isAllOf)(exports.isCreateStackBaseEvent, (0, validation_1.isObjectOf)({
    outcome: exports.isFailureStackOperationOutcome,
}));
exports.isCreateStackEvent = (0, validation_1.isSomeOf)(exports.isSuccessfulCreateStackEvent, exports.isFailureCreateStackEvent);
const isUpdateStackBaseEvent = (0, validation_1.isObjectOf)({
    operation: (0, validation_1.isLiteral)('UPDATE'),
    stackId: uuid_1.isUUID,
    updateId: validation_1.isNumber,
});
exports.isSuccessfulUpdateStackEvent = (0, validation_1.isAllOf)(isUpdateStackBaseEvent, (0, validation_1.isObjectOf)({
    outcome: exports.isSuccessfulStackOperationOutcome,
}));
exports.isNoChangeUpdateStackEvent = (0, validation_1.isAllOf)(isUpdateStackBaseEvent, (0, validation_1.isObjectOf)({
    outcome: exports.isNoChangeStackOperationOutcome,
}));
exports.isFailureUpdateStackEvent = (0, validation_1.isAllOf)(isUpdateStackBaseEvent, (0, validation_1.isObjectOf)({
    outcome: exports.isFailureStackOperationOutcome,
}));
exports.isUpdateStackEvent = (0, validation_1.isSomeOf)(exports.isSuccessfulUpdateStackEvent, exports.isFailureUpdateStackEvent, exports.isNoChangeUpdateStackEvent);
const isDeleteStackBaseEvent = (0, validation_1.isObjectOf)({
    operation: (0, validation_1.isLiteral)('DELETE'),
    stackId: uuid_1.isUUID,
});
exports.isSuccessfulDeleteStackEvent = (0, validation_1.isAllOf)(isDeleteStackBaseEvent, (0, validation_1.isObjectOf)({
    outcome: exports.isSuccessfulStackOperationOutcome,
}));
exports.isFailureDeleteStackEvent = (0, validation_1.isAllOf)(isDeleteStackBaseEvent, (0, validation_1.isObjectOf)({
    outcome: exports.isFailureStackOperationOutcome,
}));
exports.isNoChangeDeleteStackEvent = (0, validation_1.isAllOf)(isDeleteStackBaseEvent, (0, validation_1.isObjectOf)({
    outcome: exports.isNoChangeStackOperationOutcome,
}));
exports.isDeleteStackEvent = (0, validation_1.isSomeOf)(exports.isSuccessfulDeleteStackEvent, exports.isFailureDeleteStackEvent, exports.isNoChangeDeleteStackEvent);
exports.isCancelStackEvent = (0, validation_1.isObjectOf)({
    operation: (0, validation_1.isLiteral)('CANCEL'),
    outcome: exports.isStackOperationOutcome,
    stackId: uuid_1.isUUID,
    updateId: validation_1.isNumber,
});
exports.isStackEvent = (0, validation_1.isSomeOf)(exports.isCreateStackEvent, exports.isUpdateStackEvent, exports.isCancelStackEvent, exports.isDeleteStackEvent);
//# sourceMappingURL=stacks.js.map